"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShapePinComponentSchema = void 0;
const zod_1 = require("zod");
const shadow_setting_1 = require("../setting/shadow-setting");
const base_pin_component_1 = require("./base-pin-component");
const shape_utils_1 = require("./shape.utils");
const ShapeSettingsSchema = base_pin_component_1.BasePinComponentSettingsSchema.merge(zod_1.z.object({
    fillColor: zod_1.z.string().min(1).optional(),
    strokeColor: zod_1.z.string().min(1).optional(),
    strokeThickness: zod_1.z.number().optional(),
    shadow: shadow_setting_1.ShadowSettingKeySchema,
    shapeType: shape_utils_1.ShapeTypeSchema,
}));
exports.ShapePinComponentSchema = base_pin_component_1.BasePinComponentSchema.merge(zod_1.z.object({
    type: zod_1.z.literal('SHAPE'),
    settings: ShapeSettingsSchema,
}));
//# sourceMappingURL=shape-pin-component.js.map